import { CountryBaseV1 } from "./Country";
import { IReference } from "./IReference";

export class CityReferenceV1 implements IReference {
  public id: number;

  public constructor(id?: number) {
    this.id = id || 0;
  }
}

export class CityBaseV1 extends CityReferenceV1 {
  public code: string;
  public name: string;
  public zone: string;
  public country: CountryBaseV1;

  public constructor() {
    super();
    this.code = "";
    this.name = "";
    this.zone = "";
    this.country = new CountryBaseV1();
  }
}

export class CityV1 extends CityBaseV1 {
  public constructor() {
    super();
  }
}
